var _g;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgSchedule = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "3 3 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1923 -1279)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    opacity: 0,
    width: 24,
    height: 24,
    transform: "translate(1947 1279) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    fill: "none",
    strokeLinejoin: "round",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2px",
    transform: "translate(1928 1284)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0,0H12a2,2,0,0,1,2,2V12a2,2,0,0,1-2,2H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    x: 1,
    y: 1,
    width: 12,
    height: 12,
    rx: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    fill: "none",
    strokeLinejoin: "round",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2px",
    transform: "translate(1931 1284)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0,0H9a2,2,0,0,1,2,2V12a2,2,0,0,1-2,2H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    x: 1,
    y: 1,
    width: 9,
    height: 12,
    rx: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2px",
    x2: 10,
    transform: "translate(1929.5 1292.5)"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2px",
    x2: 6,
    transform: "translate(1931.5 1296.5)"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2px",
    y1: 1,
    transform: "translate(1934.5 1287.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M570.5,176a4,4,0,0,0-4-4,1,1,0,0,0,0,2,2,2,0,0,1,0,4,1,1,0,0,0,0,2A4,4,0,0,0,570.5,176Z",
    transform: "translate(1758.5 1858) rotate(-90)"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSchedule, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/schedule.5300c5e5.svg";
export { ForwardRef as ReactComponent };